import React from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { US, HU } from 'country-flag-icons/react/3x2';
import { locale } from 'primereact/api';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/hu';
import 'dayjs/locale/en';

dayjs.extend(localizedFormat);

const LanguageToggle: React.FC = () => {
    const { i18n } = useTranslation();
    const menu = React.useRef<Menu>(null);

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        locale(lng);
        dayjs.locale(lng);
    };

    const items = [
        {
            label: 'English',
            icon: <US title="English" style={{ width: 24, height: 24, marginRight: 6 }} />,
            command: () => changeLanguage('en')
        },
        {
            label: 'Magyar',
            icon: <HU title="Magyar" style={{ width: 24, height: 24, marginRight: 6 }} />,
            command: () => changeLanguage('hu')
        }
    ];

    return (
        <>
            <Button icon="pi pi-globe" onClick={(event) => menu.current?.toggle(event)}   />
            <Menu model={items} popup ref={menu} />
        </>
    );
};

export default LanguageToggle;